import PropTypes from "prop-types";
import { ReactComponent as InformationCircle } from "@/assets/svgs/iconBadgeProgress.svg";
import { ReactComponent as IconConfigure } from "@/assets/svgs/info-circle.svg";
import Modal from "@/componentsDS/Modal/Modal";
import useModal from "@/hooks/use-modal/index";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Button from "@/components/Button";

const RemarksComponent = ({
	remarks,
	setRemarks,
	showTextArea = false,
	showLearnmore = true,
	showTextAreaValue = false,
	placeHolder = "Enter Remark Here",
	showRemarksDivForTransfer = false,
	showRemarksInformation = false,
	showBackgroundColor = false,
	showExtraRemarksInformation = false
}) => {

	/*=================================================
		Modal
	/================================================*/
	const {
		visible: isVisible,
		show: showRemarksModal,
		hide: hideRemarksModal,
	} = useModal();

	return (
		<>
			<div className={showBackgroundColor ? "etr__record-details-approvals__section__blockchain__grid" : "etr__record-details__section__blockchain__grid"}>
				<div className="etr__record-details__section__content__grid__item">
					<div className="etr__record-details__section__content__grid__token-registry">
						<label
							htmlFor="etr-dropdown"
							className="etr__record-details__modal__form__input__label"
						>
							Remarks:
						</label>
						{showLearnmore && <label
							htmlFor="learn-more"
							className="etr__record-details__section__content__grid__token-registry__input__label"
							onClick={showRemarksModal}
						>
							<InformationCircle /> Learn More
						</label>}
					</div>
					{showTextArea && <><textarea
						type="text"
						maxLength={120}
						rows="3"
						placeholder={placeHolder}
						value={remarks}
						onChange={(e) => setRemarks(e.target.value)}
						autoComplete="off"
					/>
						<div className="etr__record-details__section__content__grid__item__char__count">
							<div>Maximum 120 characters</div>
							<div>{String((remarks || '').length).padStart(3, "0")}/120</div>
						</div></>}
					{showTextAreaValue && <div className="etr__record-details__section__side-panel__label-value">
						{remarks?.trim().length ? remarks?.trim() : "-"}
					</div>}
				</div>
				{showTextArea && !showRemarksDivForTransfer && <div className="etr__record-details__section__content__grid__item" />}
				{showRemarksInformation && <div className="etr__record-details__remarks-section__information">
					<div className="etr__record-details__remarks-section__information-text">
						<InformationCircle />
						<span>Any remarks provided will be accessible in the endorsement chain by any verifiers of this document.</span>
					</div>
					{showExtraRemarksInformation && <div className="etr__record-details__remarks-section__information-text etr__record-details__remarks-section__information-add-margin">
						<div></div>
						<div>Users are recommended to include the term [Surrender] or [Convert to Paper] in the remarks box when surrendering the eBL or converting the eBL to paper respectively.</div>
					</div>}
				</div>}
			</div>

			<Modal
				visible={isVisible}
				variant="medium"
				close={hideRemarksModal}
			>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div
											className={
												"card-configure__token-registry-version__icon"
											}
										>
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											About Token Registry Remarks
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="card-configure__remarks__body__text">
								Any remarks provided will be accessible in the
								endorsement chain by any verifiers of this
								document.
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								text="Dismiss"
								full
								round
								submit={() => {
									hideRemarksModal();
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	);
};

RemarksComponent.propTypes = {
	remarks: PropTypes.string,
	setRemarks: PropTypes.func,
	showTextArea: PropTypes.bool,
	showLearnmore: PropTypes.bool,
	showTextAreaValue: PropTypes.bool,
	placeHolder: PropTypes.string,
	showRemarksDivForTransfer: PropTypes.bool,
	showRemarksInformation: PropTypes.bool,
	showBackgroundColor: PropTypes.bool,
	showExtraRemarksInformation: PropTypes.bool
};

export default RemarksComponent;
